import type { IChartDataResult } from "@/pages/CreatorAnalytics/types";

export const getSeriesLabels = (chartData: IChartDataResult): string[] =>
  chartData.columns.slice(1).map((col) => (typeof col === "string" ? col : col.label));
